import { Skeleton, type SkeletonProps } from '@mui/material';

export const TextSkeleton = (props: SkeletonProps) => (
  <Skeleton variant="text" animation="wave" {...props} />
);
